// export const CARDS_BASE_URL = "http://localhost:3001";
export const CARDS_BASE_URL = "https://card.cards.army";
export const CARD_CDN = `${CARDS_BASE_URL}/cards/`;
export const CARD_CDN_THUMB = `${CARDS_BASE_URL}/cards/3/`;
